import { render, staticRenderFns } from "./SoftwareComponentVersionsSingleList.vue?vue&type=template&id=7ff24816&"
import script from "./SoftwareComponentVersionsSingleList.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentVersionsSingleList.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentVersionsSingleList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports